import React, { Component } from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { inject, observer } from 'mobx-react';

import Header from '../Header/Header.js';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import AnswerPrompt from './styledComponents/AnswerPrompt.js';
import ButtonWrapper from './styledComponents/ButtonWrapper.js';
import CalculatingMessage from './styledComponents/CalculatingMessage.js';
import ContinueButton from './styledComponents/ContinueButton.js';
import FactsWrapper from './styledComponents/FactsWrapper.js';
import RestartButton from './styledComponents/RestartButton.js';
import ReviewButton from './styledComponents/ReviewButton.js';
import ReviewWrapper from './styledComponents/ReviewWrapper.js';
import Text from './styledComponents/Text.js';
import Wrapper from './styledComponents/Wrapper.js';
import { IResultsProps, IResultsState } from './models';

type ITextProps = components.base.Text.models.ITextProps;

const LinearProgressBar = components.base.LinearProgressBar.LinearProgressBar;
const RadioButtons = components.base.RadioButtons.RadioButtons;
const ProgressIndicator = components.base.ProgressIndicator.ProgressIndicator;
const Fact = components.fact.Fact.Fact;

class RawResults extends Component<IResultsProps, IResultsState> {
	static configurationKey = 'results' as const;
	static styleKey = 'results' as const;
	constructor(props: IResultsProps) {
		super(props);
	}

	getReviewQuestions(reviewQuestions: any[], answerPromptProps: ITextProps) {
		return reviewQuestions.map((reviewQuestion, index) => {
			return (
				<div key={'review-question-' + index}>
					<Text value={reviewQuestion.name} hasHtmlContent={true} />
					<AnswerPrompt {...answerPromptProps} />
					<RadioButtons {...reviewQuestion.radioButtonsProps} disabled={true} />
				</div>
			);
		});
	}

	render() {
		const { className, resultsStore } = this.props;

		if (!resultsStore) {
			return null;
		}

		if (resultsStore.calculating) {
			return (
				<Wrapper className={className}>
					<Header />
					<CalculatingMessage>{resultsStore.calculatingMessage}</CalculatingMessage>
					<LinearProgressBar {...resultsStore.progressBarProps} />
				</Wrapper>
			);
		}

		const {
			answersFactProps,
			percentFactProps,
			restartButtonProps,
			reviewButtonProps,
			showReview,
			reviewQuestions,
			answerPromptProps,
			continueButtonProps,
		} = resultsStore;

		const { progressIndicatorProps } = resultsStore.questionWizardStore;
		return (
			<Wrapper className={className}>
				<Header />
				<FactsWrapper>
					<Fact {...answersFactProps} />
					<Fact {...percentFactProps} />
				</FactsWrapper>
				<ButtonWrapper>
					{restartButtonProps && <RestartButton {...restartButtonProps} />}
					{reviewButtonProps && <ReviewButton {...reviewButtonProps} />}
					{continueButtonProps && <ContinueButton {...continueButtonProps} />}
				</ButtonWrapper>
				{showReview && (
					<ReviewWrapper>
						<ProgressIndicator {...progressIndicatorProps} />
						{this.getReviewQuestions(reviewQuestions, answerPromptProps)}
					</ReviewWrapper>
				)}
			</Wrapper>
		);
	}
}

export const Results = inject('appStore', 'resultsStore')(observer(RawResults));
export default InjectedStyledComponent(Results, 'results');
